namespace nscs.screen.stories {

    export class AnimationRunningCharacters_2 extends Phaser.GameObjects.Container {

        frame = {name:'AnimationRunningCharacters_2'};

        _bg:Phaser.GameObjects.Image;
        ground0_1:Phaser.GameObjects.Image;
        ground0_2:Phaser.GameObjects.Image;
        _nuget:Phaser.GameObjects.Sprite;
        _chick:Phaser.GameObjects.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene);


            this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg2' + '0000');
            this._bg.setOrigin(0, 0);

            this.ground0_1 = this.scene.add.image(game.scale.width/2, 325, 'stories', 'ground0' + '0000');
            this.ground0_1.setOrigin(0.5, 1);
            this.ground0_2 = this.scene.add.image(this.ground0_1.x + this.ground0_1.width, this.ground0_1.y, 'stories', 'ground0' + '0000');
            this.ground0_2.setOrigin(0.5, 1);

            this._nuget = this.scene.add.sprite(-350, 300, 'stories', '_nuget' + '0000');
            this._nuget.setOrigin(0.5, 1);

            this._chick = this.scene.add.sprite(-200, 302, 'stories', '_chick' + '0000');
            this._chick.setOrigin(0.5, 1);

            this.add([this._bg, this.ground0_1, this.ground0_2, this._chick, this._nuget]);

            this.scene.tweens.add({
                targets: this._bg,
                duration: 6000,
                x: this._bg.x-50,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.ground0_1,
                duration: 6000,
                x: this.ground0_1.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.ground0_2,
                duration: 6000,
                x: this.ground0_2.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            
            this.scene.tweens.add({
                targets: this._nuget,
                duration: 4000,
                x: this._nuget.x + 875,
            });
            this.scene.tweens.add({
                targets: this._chick,
                duration: 4000,
                x: this._chick.x + 825,
                delay: 150
            });

            let anim:string = nscs.gameplay.Factory.createAnimName('_nuget', 'walking');
            if (!this.scene.anims.exists(anim)) {
                this.scene.anims.create({
                    key: anim,
                    frames: this.scene.anims.generateFrameNames(this._nuget.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_nuget', suffix: ''
                    }),
                    repeat: -1,
                    frameRate: 60
                });
            }
            util.Functions.delayedCall(150, ()=>{
                this._nuget.play(anim);
            });
            let _anim = nscs.gameplay.Factory.createAnimName('_chick', 'walking');
            if (!this.scene.anims.exists(_anim)) {
                this.scene.anims.create({
                    key: _anim,
                    frames: this.scene.anims.generateFrameNames(this._chick.texture.key, {
                        start: 0, end: 30, zeroPad: 4,
                        prefix: '_chick', suffix: ''
                    }),
                    repeat: -1,
                    frameRate: 60
                });
            }
            this._chick.play(_anim);
            
            util.Functions.delayedCall(6000, ()=>{
                this.showSecondPart();
            });
        }

        public showSecondPart():void {
            AnimationRunningCharacters_2.showDust(300, 450, this, 1);
        }
        
        public static showDust(x:number, y:number, parent, ind):Phaser.GameObjects.Container {
            nscs.sound.SoundManager.getInstance().playMusic('scarySND', false);
            
            let cnt = new Phaser.GameObjects.Container(parent.scene);
            cnt.setPosition(x, y);
            for (let i = 0; i < 15; i++) {
                let dust = new Phaser.GameObjects.Image(parent.scene, 0, 0, 'stories', 'dust_' + '0000');
                cnt.add(dust);
                dust.alpha = 0;
                parent.scene.tweens.add({
                    targets: dust,
                    duration: 10000,
                    y: dust.y - 750 - Math.random() * 200,
                    alpha: 1,
                    scale: 1 + Math.random()*0.5,
                    delay: (Math.random() * 50 + 100) * i,
                    angle: Math.random() * 60
                });
                parent.scene.tweens.add({
                    targets: dust,
                    duration: 10000,
                    x: dust.x + (Math.random() - 0.5) * 275,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    delay: (Math.random() * 250 + 650) * i
                });
            }
            parent.addAt(cnt, ind);
            return cnt;            
        }
    }
}